import styled from "styled-components";
import { Modal } from "components/Modal";

export const PlanConfirmationModalContainer = styled(Modal)`
  z-index: 1060;

  &.modal {
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-dialog {
    max-width: 420px;
  }

  .modal-content {
    padding: 24px 32px 28px;
    border-radius: 16px;
  }

  .modal-body {
    padding: 0;
    margin-top: 0;
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;
    }

    .modal-content {
      padding: 20px;
    }
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
`;

export const TitleIcon = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #3677fb;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: ${({ theme }) => theme.card.font.tertiary};
  font-family: "Geist", sans-serif;
`;

export const InfoBox = styled.div`
  border-radius: 12px;
  background: #eff5ff;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
`;

export const InfoIcon = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
  color: #3677fb;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoText = styled.div`
  font-size: 14px;
  color: #414651;
  font-family: "Geist", sans-serif;
  line-height: 1.5;
`;

export const PlanNameHighlight = styled.span`
  font-weight: 600;
  color: #181d27;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
  font-family: "Geist", sans-serif;
`;

export const DetailValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.card.font.tertiary};
  font-family: "Geist", sans-serif;
`;

export const Divider = styled.div`
  margin: 8px -32px 18px;
  border-top: 1px solid ${({ theme }) => theme.divider.bg.primary};

  @media (max-width: 768px) {
    margin: 8px -20px 18px;
  }
`;

export const AttestationLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 18px;
  cursor: pointer;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.typography.color.secondary};

  input[type="checkbox"] {
    flex-shrink: 0;
    margin-top: 2px;
    width: 16px;
    height: 16px;
    appearance: auto;
    -webkit-appearance: auto;
    accent-color: ${({ theme }) => theme.typography.color.link};
    cursor: pointer;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;

    ${() => CancelButton}, ${() => ConfirmButton} {
      flex: none;
      width: 100%;
      height: 44px;
    }
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Geist", sans-serif;
  background: #ffffff;
  border: 1px solid #d5d7da;
  color: #374151;

  &:hover {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  flex: 1;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Geist", sans-serif;
  background: #2258f1;
  color: #ffffff;
  border: none;

  &:hover {
    background: #1a4bd4;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
